import Vue from 'vue';
import moment from 'moment';
import InvoiceDetails from '@/components/InvoiceDetails/InvoiceDetails.vue';
import ApiRequest from '@/tools/ApiRequest';
import RequestException from '@/tools/helpers/RequestException';

type Invoice = {
  id: number;
  invoice_status: string;
  created_at: number;
  items: [
    {
      title: string;
      quant: number;
    },
  ];
};

export default Vue.extend({
  name: 'InvoiceList',
  components: {
    'invoice-details': InvoiceDetails,
  },
  data: () => ({
    invoices: [] as Invoice[],
  }),
  computed: {
    invoiceDetails(): Vue & { open: (invoide: Invoice) => void; close: () => void } {
      return this.$refs.invoiceDetails as Vue & { open: () => void; close: () => void };
    },
  },
  methods: {
    getInvoices(): void {
      ApiRequest.getInvoiceList()
        .then((response) => {
          this.invoices = response.data;
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    formatDate(time: number): string {
      return moment.unix(time).format('DD/MM/YYYY HH:mm');
    },
    invoiceClick(invoice: Invoice): void {
      if (invoice.invoice_status === 'Aprovado') {
        this.invoiceDetails.open(invoice);
      } else if (invoice.invoice_status !== null) {
        this.$router.push('/cadastrar-nota');
      }
    },
  },
  created(): void {
    this.getInvoices();
  },
});
